export const saveFile = (file: File) => {
  const anchor = document.createElement("a");
  anchor.download = file.name;
  anchor.href = window.URL.createObjectURL(file);
  anchor.click();
};
